module.exports = __webpack_public_path__ + "img/11 On y va _.79b3db02.png";